// Lời luận đầu tiên của Bói Đê được render ngoài khung chat (ChatPanel ẩn nó đi
// bằng hideInitialAssistant) nên trước đây không có chỗ chấm điểm. Component này
// gắn lại hàng sao cho đúng message assistant đầu tiên của phiên.
import { useQuery } from "@tanstack/react-query";

import { StarRating } from "@/components/star-rating";
import { chatHistoryKey, useChatRating } from "@/components/boi-de/use-chat-rating";
import { getChatHistory } from "@/lib/boide-api";

export function InitialReadingRating({
  sessionId,
  className,
}: {
  sessionId: string;
  className?: string;
}) {
  const history = useQuery({
    queryKey: chatHistoryKey(sessionId),
    queryFn: () => getChatHistory(sessionId),
    enabled: Boolean(sessionId),
  });
  const rate = useChatRating(sessionId);

  const first = history.data?.messages?.[0];
  if (!first || first.role !== "assistant") return null;

  return (
    <div className={className}>
      <StarRating
        value={first.rating ?? 0}
        busy={rate.isPending}
        onRate={(v) => rate.mutate({ messageId: first.id, value: v })}
        comment={first.rating_comment}
        commentRewarded={Boolean(first.rating_comment_rewarded_at)}
        onComment={(comment) =>
          rate.mutate({ messageId: first.id, value: first.rating ?? null, comment })
        }
      />
    </div>
  );
}
